var is_mobile = window.matchMedia("(max-width: 768px)").matches;
function handleModelsCarousel() {
  let els = document.querySelectorAll('[data-swiper="models-carousel"]')
  
  if(els == undefined) return
  
  if(window.matchMedia("(max-width: 768px)").matches == true) {
    els.forEach( e => {
      
      if(!e.classList.contains('swiper-initialized')) {
          e.classList.add('swiper')
          e.querySelector("ul").classList.add("swiper-wrapper")
          const swiper = new Swiper(e, {
            slidesPerView: 'auto',
            spaceBetween: 20,
            freeMode: {
              enabled: true
            },
            pagination: {
              el: '.swiper-pagination',
            }
          })
        } else if(!is_mobile) {
          is_mobile = true;
          e.swiper.destroy();
          e.querySelectorAll('.swiper-slide').forEach(el=>{
            el.style.flex = null;
          })
          const swiper = new Swiper(e, {
            slidesPerView: 'auto',
            spaceBetween: 20,
            freeMode: {
              enabled: true
            },
            pagination: {
              el: '.swiper-pagination',
            }
          });
        }
    })
  } else {
    els.forEach( e => { 
      if(!e.matches('[data-enable-slider-desktop]')) {
        if(e.classList.contains('swiper-initialized')) {
            e.swiper.destroy()
          }
          e.classList.remove('swiper')
          e.querySelector("ul").classList.remove('swiper-wrapper')
        } else {
          els.forEach( e => {
            if(!e.classList.contains('swiper-initialized')) {
                e.querySelectorAll('.swiper-slide').forEach(el=>{
                  el.style.flex = 'none';
                })
                e.classList.add('swiper')
                e.querySelector("ul").classList.add("swiper-wrapper")
                const swiper = new Swiper(e, {
                  slidesPerView: parseFloat(e.dataset.columnsDesktop),
                  spaceBetween: 15,
                  freeMode: {
                    enabled: true
                  },
                  navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                  }
                })
              } else if(is_mobile) {
                is_mobile = false;
                e.swiper.destroy();
                e.querySelectorAll('.swiper-slide').forEach(el=>{
                  el.style.flex = 'none';
                })
                e.classList.add('swiper')
                e.querySelector("ul").classList.add("swiper-wrapper")
               const swiper = new Swiper(e, {
                  slidesPerView: parseFloat(e.dataset.columnsDesktop),
                  spaceBetween: 15,
                  freeMode: {
                    enabled: true
                  },
                  navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                  }
                })
              }
          })
        }
      })
  }

}

handleModelsCarousel();

window.addEventListener("resize", () => {
  handleModelsCarousel()
})